// custom script for the refer-a-friend page start //

document.querySelectorAll('.comn_btn_box-inner > a.button.button--primary').forEach(button => {
  button.addEventListener('click', function (e) {
    e.preventDefault();

    setTimeout(() => {      
      const target = document.getElementById('affiliate-sign-up-form');
      const sectiontarget = target?.closest(".shopify-section");

      const header = document.querySelector('.header-sticky, .sticky-header');

      if (target && sectiontarget) {
        const headerHeight = header ? header.offsetHeight : 0;
        const elementPosition = sectiontarget.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerHeight - 150; 

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 100); // Optional delay if content is dynamic
  });
});

// custom script for the refer-a-friend page end //

const manualLoopDiscountPercentage = 20;


$(document).ready(function () {

  function determinePackSizeFromSpan(spanElement) {
    // Default pack size
    var packSize = 1;

    // Check if the data-pack-name attribute exists and parse it
    var packName = spanElement.getAttribute('data-pack-name');
    // console.log(`In determinePackSizeFromSpan:: Pack name: ${packName}`);
    if (packName) {
      // Attempt to extract the first number from the data-pack-name as the pack size
      var match = packName.match(/\d+/);
      if (match) {
        packSize = parseInt(match[0], 10);
      }
    }
    // console.log(`In determinePackSizeFromSpan:: Pack size: ${packSize}`);
    return packSize;
  }




  function updatePricingUI(pricePerBag, pricePerServing, selectedVariantSpan, type, targetPricingTab) {
    // Initially set the formatted prices without applying any discount
    // var formattedPricePerServing = `(${pricePerServing.toFixed(2)} / serving)`;
    var formattedPricePerServing = `(${loopFormatMoney(pricePerServing * 100, false)} / serving)`;
    var formattedPricePerBag = loopFormatMoney(pricePerBag * 100, false);
  
    // Determine whether to apply the manual discount based on the active pricing tab
    //If we're selecting a one time variant and we want to update the price for the subscription tab to the same pack size...
    if (targetPricingTab === "subscribe-tab" && type === 'one-time') {
      console.log(`1: Active pricing tab: ${targetPricingTab}, type of variant selected: ${type}`);
      // If we're on the subscribe tab but selecting a one-time variant, calculate the subscription prices without the manual discount
      // $('#subscription-price-per-serving').text(formattedPricePerServing);
      // $('#subscription-tab-price').text(formattedPricePerBag);
      // Calculate and display the one-time prices with the manual discount for comparison
      let discountedPricePerBag = applyManualDiscount(pricePerBag, manualLoopDiscountPercentage);
      let discountedPricePerServing = applyManualDiscount(pricePerServing, manualLoopDiscountPercentage);
      var formattedDiscountedPricePerServing = `(${loopFormatMoney(discountedPricePerServing * 100, false)} / serving)`;
      console.log(`Formatted Discounted Price Per Serving: ${formattedDiscountedPricePerServing}`)
      var formattedDiscountedPricePerBag = loopFormatMoney(discountedPricePerBag * 100, false);
      // $('#one-time-price').text(formattedDiscountedPricePerBag);
      // $('#one-time-price-per-serving').text(formattedDiscountedPricePerServing);
    } 
    
    //If we're on the subscription tab and change a variant, we want to update the the one-time tab's price to the same pack size...
    else if (targetPricingTab == "one-time" && type === 'subscription') {
      console.log(`2: Active pricing tab: ${targetPricingTab}, type of variant selected: ${type}`);
      // If we're not on the subscribe tab but selecting a subscription variant, display the subscription prices directly
      // and calculate the one-time prices with the manual discount for comparison
      let oneTimePricePerBag = pricePerBag / (1 - manualLoopDiscountPercentage / 100);
      let oneTimePricePerServing = pricePerServing / (1 - manualLoopDiscountPercentage / 100);
      var formattedOneTimePricePerServing = `(${oneTimePricePerServing.toFixed(2)} / serving)`;
      var formattedOneTimePricePerBag = loopFormatMoney(oneTimePricePerBag * 100, false);
      // $('#subscription-price-per-serving').text(formattedPricePerServing);
      // $('#subscription-tab-price').text(formattedPricePerBag);
      $('#one-time-price').text(formattedOneTimePricePerBag);
      $('#one-time-price-per-serving').text(formattedOneTimePricePerServing);
    } 
    
    else {
      console.log(`3: Active pricing tab: ${targetPricingTab}, type of variant selected: ${type}`);
      // For all other cases, use the prices as they are without applying the manual discount
      if (type === 'subscription') {
        $('#subscription-price-per-serving').text(formattedPricePerServing);
        $('#subscription-tab-price').text(formattedPricePerBag);
      } else {
        $('#one-time-price').text(formattedPricePerBag);
        $('#one-time-price-per-serving').text(formattedPricePerServing);
      }
    }
  }
  
  function applyManualDiscount(price, discountPercentage) {
    return price * (1 - discountPercentage / 100);
  }

  $('.section-question-answer .question-answer-wrapper li .question').on('click', function () {
    $(this).toggleClass('active');
    $(this).next('.answer').slideToggle();
  });
  // review page JS
  $(".custom-review-inner .review_block").slice(0, 6).show();
  $("body").on('click touchstart', '.loadmore span', function (e) {
    e.preventDefault();
    $(".custom-review-inner .review_block:hidden").slice(0, 2).show();
    if ($(".custom-review-inner .review_block:hidden").length == 0) {
      $(".loadmore span").css('visibility', 'hidden');
    }
  });

  $("[data-btn-load-more]").on("click", function (event) {
    event.preventDefault();
    $(".page-blog-collection .image-with-text-columns-item.hidden").each(
      function (index, item) {
        if (index < 3) {
          $(item).removeClass("hidden");
        }
      }
    );
    if ($(".page-blog-collection .image-with-text-columns-item.hidden").length == 0) {
      $(this).addClass("hidden");
    }
  });
  
  $("[data-btn-load-more]").on("click", function (event) {
    event.preventDefault();
    $(".page-blog-collection .image-with-text-columns-item-mobile.hidden").each(
      function (index, item) {
        if (index < 4) {
          console.log("remove the class");
          $(item).removeClass("hidden");
        }
      }
    );
    if ($(".page-blog-collection .image-with-text-columns-item-mobile.hidden").length == 0) {
      $(this).addClass("hidden");
    }
  });



  if ($('body').hasClass('template-product') || $('body').hasClass('template-index')) {
     //show free gift products
             // $('variant-radios fieldset').each(function(){
             //    var var_title = $(this).find('input[type="radio"]:checked').val();
             //    var var_title_down = var_title.toLowerCase();
             //    if(var_title_down.includes('12') && var_title_down.includes('bags')){
             //      $('.free-gift-block .free-gift-products .product-box').addClass('active');
             //    }else if(var_title_down.includes('9') && var_title_down.includes('bags')){
             //      $('.free-gift-block .free-gift-products .product-box').addClass('active');
             //    }
             //    else if(var_title_down.includes('6') && var_title_down.includes('bags')){
             //      $('.free-gift-block .free-gift-products .product-box:lt(6)').addClass('active');
             //      $('.free-gift-block .free-gift-products .product-box:gt(5)').removeClass('active');
             //    }else if(var_title_down.includes('3') && var_title_down.includes('bags')){
             //      $('.free-gift-block .free-gift-products .product-box:lt(2)').addClass('active');
             //      $('.free-gift-block .free-gift-products .product-box:gt(1)').removeClass('active');
             //    }else{
             //      $('.free-gift-block .free-gift-products .product-box:first').addClass('active');
             //      $('.free-gift-block .free-gift-products .product-box:gt(0)').removeClass('active');
             //    }
             //  });

    if($('body').hasClass('template-product-ian-product-template') || $('body').hasClass('template-product-ian-product-template-duplicate') || $('body').hasClass('template-product-ian-product-template-ver1') || $('body').hasClass('template-product-ian-product-template-ver2') || $('body').hasClass('template-product-ian-product-template-ver3') || $('body').hasClass('template-product-ian-product-template-ver4') || $('body').hasClass('template-product-ian-product-template-ver5') || $('body').hasClass('template-product-ian-product-template-ver6') || $('body').hasClass('template-product-ian-product-template-ver7') || $('body').hasClass('template-product-ian-product-template-ver8') || $('body').hasClass('template-product-ian-product-template-ver9') || $("body").hasClass("template-product-better-sleep-product-template")
      || $('body').hasClass('template-product-mushroom-collagen-coffee-product-template') || $('body').hasClass('template-product-the-complete-gut-repair-product-template') || $('body').hasClass('template-product-menopause-joint-repair-blend') || $('body').hasClass('template-product-ian-product-template-ver10') || $('body').hasClass('template-product-ian-product-template-ver11') || $('body').hasClass('template-product-ian-product-template-ver12') || $('body').hasClass('template-product-ian-product-template-ver13') || $('body').hasClass('template-product-beef-organs-templates') || $('body').hasClass('template-product-collagen-greens-product-template') || $('body').hasClass('template-product-ashwagandha-capsules-template') || $('body').hasClass('template-product-probiotic-complex-template')
      || $('body').hasClass('template-product-glucosamine-complex-template') || $('body').hasClass('template-product-moringa-capsules-template') || $('body').hasClass('template-product-niacinamide-complex-template') || $('body').hasClass('template-product-berberine-capsules-template') || $('body').hasClass('template-product-tumeric-complex-template') || $('body').hasClass('template-index') || $('body').hasClass('template-product-the-complete-gut-repair-product-template-ver1') || $('body').hasClass('template-product-better-sleep-product-template-ver1') || $('body').hasClass('template-product-collagen-greens-product-template-ver1') || $('body').hasClass('template-product-menopause-joint-repair-blend-ver1') || $('body').hasClass('template-product-mushroom-collagen-coffee-product-template-ver1')){
    // if($('body').hasClass('template-product-ian-product-template')){
        var isALARendered_ian;
        function ALAcheck_ian() {
        isALARendered_ian = setInterval(function () {
          customALA_ian()
        }, 900);
        }
        ALAcheck_ian();
        function customALA_ian() {
          var selector = $('.loop-subscription-container:first .loop-selling-plan-fieldset');
          if (selector.length > 0) {
            clearInterval(isALARendered_ian);
            $('.loop-subscription-container:first .loop-selling-plan-fieldset').find('.loop-product-subscribe').each(function (index) {
                if ($(this).css('display') == 'block') {
                  $(this).find('.loop-full-width').trigger('click');
                  var subscribe_price = $(this).find('.loop-subscription-group-price-container .loop-subscription-group-price-amount').attr('data-subscribe-price');
                  // var original_price = $(this).find('.loop-subscription-group-price-container .loop-subscription-group-price-amount').attr('data-original-price');
                  $('.product-form__submit .price_text .discounted_price').text(subscribe_price);
                  // $('.product-form__submit .price_text .compare_price_cross').text(original_price);
                }
            });

            //flavour
            var flavour = $('fieldset.variant-flavour').find('input[type="radio"]:checked').val();
            if(flavour == 'Unflavoured' || flavour == 'Vanilla' ){
              // $('.product-form__submit span:first').text('Pre Order (1ST SEPTEMBER)');
            }

            // //show free gift products
             $('variant-radios fieldset').each(function(){
                var var_title = $(this).find('input[type="radio"]:checked').val();
                var var_title_down = var_title.toLowerCase();
                console.log('var_title_down',var_title_down);
                if(var_title_down.includes('12') && var_title_down.includes('bags')){
                  $('.free-gift-block .free-gift-products .product-box').addClass('active');
                }else if(var_title_down.includes('9') && var_title_down.includes('bags')){
                  $('.free-gift-block .free-gift-products .product-box').addClass('active');
                }
                else if(var_title_down.includes('6') && var_title_down.includes('bags')){
                  if($(this).hasClass('with_people')){
                    var var_title_people = $('fieldset.variant-people').find('input[type="radio"]:checked').val();
                    var var_title_people_down = var_title_people.toLowerCase();

                    if(var_title_people_down.includes('2') && var_title_people_down.includes('people')){
                      $('.free-gift-block .free-gift-products .product-box').addClass('active');
                    }else{
                      $('.free-gift-block .free-gift-products .product-box:lt(6)').addClass('active');
                      $('.free-gift-block .free-gift-products .product-box:gt(5)').removeClass('active');
                    }
                  }else{
                    $('.free-gift-block .free-gift-products .product-box:lt(6)').addClass('active');
                    $('.free-gift-block .free-gift-products .product-box:gt(5)').removeClass('active');
                  }
                }else if(var_title_down.includes('3') && var_title_down.includes('bags')){
                  if($(this).hasClass('with_people')){
                    var var_title_people = $('fieldset.variant-people').find('input[type="radio"]:checked').val();
                    var var_title_people_down = var_title_people.toLowerCase();
                     if(var_title_people_down.includes('2') && var_title_people_down.includes('people')){
                       $('.free-gift-block .free-gift-products .product-box:lt(6)').addClass('active');
                       $('.free-gift-block .free-gift-products .product-box:gt(5)').removeClass('active');
                    }else{
                      $('.free-gift-block .free-gift-products .product-box:lt(2)').addClass('active');
                      $('.free-gift-block .free-gift-products .product-box:gt(1)').removeClass('active');
                    }
                  }else{
                    $('.free-gift-block .free-gift-products .product-box:lt(2)').addClass('active');
                    $('.free-gift-block .free-gift-products .product-box:gt(1)').removeClass('active');
                  }
                }else{
                  $('.free-gift-block .free-gift-products .product-box:first').addClass('active');
                  $('.free-gift-block .free-gift-products .product-box:gt(0)').removeClass('active');
                }
              });
            
          }
        }
        $('.s_selector').click(function (event) {
          // If the event was triggered by a child input field, stop here
          if ($(event.target).is('input[type="radio"]')) {
            return;
          }
          $('.s_selector').removeClass('selected');
          $(this).addClass('selected');
          // Simulate a click on the child input field
          $(this).find('input[type="radio"]').click();
        });
        
        // When the child input field is clicked, trigger a click on the parent s_selector
        $('.s_selector input[type="radio"]').change(function (event) {
          console.log('hhhhhh')
          event.stopPropagation();
          $('.s_selector').removeClass('selected');
          $(this).parents('.s_selector').addClass('selected');

          //free gift
              // $('variant-radios fieldset').each(function(){
              //   var var_title = $(this).find('input[type="radio"]:checked').val();
              //   var var_title_down = var_title.toLowerCase();

              //   if(var_title_down.includes('12') && var_title_down.includes('bags')){
              //     $('.free-gift-block .free-gift-products .product-box').addClass('active');
              //   }else if(var_title_down.includes('9') && var_title_down.includes('bags')){
              //     $('.free-gift-block .free-gift-products .product-box').addClass('active');
              //   }
              //   else if(var_title_down.includes('6') && var_title_down.includes('bags')){
              //     $('.free-gift-block .free-gift-products .product-box:lt(6)').addClass('active');
              //     $('.free-gift-block .free-gift-products .product-box:gt(5)').removeClass('active');
              //   }
              //   else if(var_title_down.includes('3') && var_title_down.includes('bags')){
              //     $('.free-gift-block .free-gift-products .product-box:lt(2)').addClass('active');
              //     $('.free-gift-block .free-gift-products .product-box:gt(1)').removeClass('active');
              //   }else{
              //     $('.free-gift-block .free-gift-products .product-box:first').addClass('active');
              //     $('.free-gift-block .free-gift-products .product-box:gt(0)').removeClass('active');
              //   }
              // });
          
          var id = $(this).attr('id');
            if(id == 'subscribe'){
              // $('variant-radios fieldset').each(function(){
              //   var var_title = $(this).find('input[type="radio"]:checked').val();
              //   var var_title_down = var_title.toLowerCase();

              //   if(var_title_down.includes('6') && var_title_down.includes('bags')){
              //     $('.free-gift-block .free-gift-products .product-box').addClass('active');
              //   }else if(var_title_down.includes('3') && var_title_down.includes('bags')){
              //     $('.free-gift-block .free-gift-products .product-box:lt(2)').addClass('active');
              //     $('.free-gift-block .free-gift-products .product-box:gt(1)').removeClass('active');
              //   }else{
              //     $('.free-gift-block .free-gift-products .product-box:first').addClass('active');
              //     $('.free-gift-block .free-gift-products .product-box:gt(0)').removeClass('active');
              //   }
              // });
              //free gift
              $('variant-radios fieldset').each(function(){
                var var_title = $(this).find('input[type="radio"]:checked').val();
                var var_title_down = var_title.toLowerCase();

                if(var_title_down.includes('12') && var_title_down.includes('bags')){
                  $('.free-gift-block .free-gift-products .product-box').addClass('active');
                }else if(var_title_down.includes('9') && var_title_down.includes('bags')){
                  $('.free-gift-block .free-gift-products .product-box').addClass('active');
                }
                else if(var_title_down.includes('6') && var_title_down.includes('bags')){
                  $('.free-gift-block .free-gift-products .product-box:lt(6)').addClass('active');
                  $('.free-gift-block .free-gift-products .product-box:gt(5)').removeClass('active');
                }
                else if(var_title_down.includes('3') && var_title_down.includes('bags')){
                  $('.free-gift-block .free-gift-products .product-box:lt(2)').addClass('active');
                  $('.free-gift-block .free-gift-products .product-box:gt(1)').removeClass('active');
                }else{
                  $('.free-gift-block .free-gift-products .product-box:first').addClass('active');
                  $('.free-gift-block .free-gift-products .product-box:gt(0)').removeClass('active');
                }
              });
              
              $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label .pack_toggle-content .one_time').addClass('hidden');
              $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label .pack_toggle-content .subscription').removeClass('hidden');
              $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label .pack_toggle_off.one_time').addClass('hidden');
              $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label .pack_toggle_off.subscribe').removeClass('hidden');
              $('.subscription-tab.custom-tab .subscribe-content').removeClass('hidden');
              $('.subscription-tab.custom-tab .onetime-content').addClass('hidden');

            if($('body').hasClass('template-product-ian-product-template')){
              $('.free-gift-text.one_time').addClass('hidden');
              $('.free-gift-text.subscription').removeClass('hidden');
            }

              var original_price = $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options input[type="radio"]:checked').next('label').find('.pack-price:visible').attr('data-compare-price');
              $('.product-form__submit .price_text .compare_price_cross').text(original_price);
              
              $('.loop-subscription-container:first .loop-selling-plan-fieldset').find('.loop-product-subscribe').each(function (index) {
                if ($(this).css('display') == 'block') {
                  $(this).find('.loop-full-width').trigger('click');
                  var subscribe_price = $(this).find('.loop-subscription-group-price-container .loop-subscription-group-price-amount').attr('data-subscribe-price');
                  // var original_price = $(this).find('.loop-subscription-group-price-container .loop-subscription-group-price-amount').attr('data-original-price');
                  $('.product-form__submit .price_text .discounted_price').text(subscribe_price);
                  // $('.product-form__submit .price_text .compare_price_cross').text(original_price);
                }
              });
            }else{
              $('.free-gift-block .free-gift-products .product-box').removeClass('active');
              
              $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label .pack_toggle-content .subscription').addClass('hidden');
              $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label .pack_toggle-content .one_time').removeClass('hidden');
              $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label .pack_toggle_off.one_time').removeClass('hidden');
              $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label .pack_toggle_off.subscribe').addClass('hidden');
              $('.subscription-tab.custom-tab .subscribe-content').addClass('hidden');
              $('.subscription-tab.custom-tab .onetime-content').removeClass('hidden');
              
              if($('body').hasClass('template-product-ian-product-template')){
                $('.free-gift-text.one_time').removeClass('hidden');
                $('.free-gift-text.subscription').addClass('hidden');
              }

              //trigger app dropdown
              setTimeout(function() {
                $('.loop-subscription-container:first .loop-selling-plan-fieldset .loop-one-time-purchase-option-position .loop-one-time-purchase-option').trigger('click');
              }, 400);
              var subscribe_price = $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options input[type="radio"]:checked').next('label').find('.pack-price:visible').attr('data-price');
              var original_price = $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options input[type="radio"]:checked').next('label').find('.pack-price:visible').attr('data-compare-price');

              var subscribe_price_int = $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options input[type="radio"]:checked').next('label').find('.pack-price:visible').attr('data-price-int');
              var original_price_int = $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options input[type="radio"]:checked').next('label').find('.pack-price:visible').attr('data-compare-price-int');

              $('.product-form__submit .price_text .discounted_price').text(subscribe_price);
              if(original_price_int > subscribe_price_int){
                  $('.product-form__submit .price_text .compare_price_cross').text(original_price);
              }else{
                  $('.product-form__submit .price_text .compare_price_cross').text('');
              }
              
              
            }
        });

      $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label').on('click', function (event) {
          console.log('hhhh')
          var sel_id = $('.subscription-tab.custom-tab .tab input[name="grp"]:checked').attr('id');
          var subs_price = $(this).find('.per_each_span').attr('data-subs-each');
          var one_time_price = $(this).find('.per_each_span').attr('data-one-time-each');

          $('.subscription-tab.custom-tab .tab #subscription-tab-price').html(subs_price);
          $('.subscription-tab.custom-tab .tab #one-time-price').html(one_time_price);
          if(sel_id == 'subscribe'){
            var original_price = $(this).find('.pack-price:visible').attr('data-compare-price');
             $('.product-form__submit .price_text .compare_price_cross').text(original_price);
            setTimeout(function () {              
              $('.loop-subscription-container:first .loop-selling-plan-fieldset').find('.loop-product-subscribe').each(function (index) {
                if ($(this).css('display') == 'block') {
                var subscribe_price = $(this).find('.loop-subscription-group-price-container .loop-subscription-group-price-amount').attr('data-subscribe-price');
                // var original_price = $(this).find('.loop-subscription-group-price-container .loop-subscription-group-price-amount').attr('data-original-price');
                $('.product-form__submit .price_text .discounted_price').text(subscribe_price);
                // $('.product-form__submit .price_text .compare_price_cross').text(original_price);
                }
              });
            },400);
          }else{
             var subscribe_price = $(this).find('.pack-price:visible').attr('data-price');
             var original_price = $(this).find('.pack-price:visible').attr('data-compare-price');
             $('.product-form__submit .price_text .discounted_price').text(subscribe_price);

            var subscribe_price_int = $(this).find('.pack-price:visible').attr('data-price-int');
            var original_price_int = $(this).find('.pack-price:visible').attr('data-compare-price-int');

              if(original_price_int > subscribe_price_int){
                  $('.product-form__submit .price_text .compare_price_cross').text(original_price);
              }else{
                  $('.product-form__submit .price_text .compare_price_cross').text('');
              }
            //  $('.product-form__submit .price_text .compare_price_cross').text(original_price);

            setTimeout(function () {
                //trigger app dropdown
                $('.loop-subscription-container:first .loop-selling-plan-fieldset .loop-one-time-purchase-option-position .loop-one-time-purchase-option').trigger('click');
              }, 400);
          }


          // change variant name for multi mix flavoured
          var this_value = $(this).find('.pack-value').text().toLowerCase();
          console.log('this_val',this_value);
          if(this_value.includes('multi') && this_value.includes('mix')){
            var qty_val = $('variant-radios fieldset.option-quantity input[type="radio"]:checked').val();
            if(qty_val.includes(1)){
              // $('variant-radios fieldset.option-quantity input[type="radio"][data-value="3-bags"]').prop('checked',true);
              $('variant-radios fieldset.option-quantity input[type="radio"][data-value="6-bags"]').next('label').trigger('click');
            }
          }

          if ((this_value.includes('3') || this_value.includes('6') || this_value.includes('9') || this_value.includes('12')) && this_value.includes('bags') && !this_value.includes('each')) {
              // console.log('hiii click');
             let mix_flavour = '';
             let mix_flavour_id = '';
             $('variant-radios fieldset.option-flavour input[type="radio"]').each(function(){
                var get_val = $(this).val().toLowerCase();
                if(get_val.includes('multi') && get_val.includes('mix')){
                  mix_flavour = $(this).val();
                  mix_flavour_id = $(this).attr('data-value');
                }
             });

            
             if(this_value.includes('3')){
               $('variant-radios fieldset.option-flavour input[type="radio"][data-value="'+mix_flavour_id+'"]').next('label').find('.pack-value').html(mix_flavour+ ' - 1 Bag Each');
             }else if(this_value.includes('6')){
               $('variant-radios fieldset.option-flavour input[type="radio"][data-value="'+mix_flavour_id+'"]').next('label').find('.pack-value').html(mix_flavour+ ' - 2 Bags Each');
             }else if(this_value.includes('9')){
               $('variant-radios fieldset.option-flavour input[type="radio"][data-value="'+mix_flavour_id+'"]').next('label').find('.pack-value').html(mix_flavour+ ' - 3 Bags Each');
             }else if(this_value.includes('12')){
               $('variant-radios fieldset.option-flavour input[type="radio"][data-value="'+mix_flavour_id+'"]').next('label').find('.pack-value').html(mix_flavour+ ' - 4 Bags Each');
             }
            
          }

        
      });

      
    }else{

    // $('div[for="subs"]').click();
      $('.s_selector').click(function (event) {
        $('.s_selector').removeClass('active');
          // If the event was triggered by a child input field, stop here
          if ($(event.target).is('input[type="radio"]')) {
            return;
          }
        
          $('.s_selector').removeClass('selected');
          $(this).addClass('selected');
          // Simulate a click on the child input field
          $(this).find('input[type="radio"]').click();
        });

    //* Update the #subscription-tab-price span with the subscription price  on page load
    setTimeout(function () {
      // Select the target node - the "Add to Cart" button in this case
      var targetNode = document.querySelector('.product-form__submit')

      // Check if the target node exists to avoid errors
      if (targetNode) {
        // Options for the observer (which mutations to observe)
        var config = { attributes: false, childList: true, subtree: true };

        // Callback function to execute when mutations are observed
        var callback = function (mutationsList, observer) {
          for (var mutation of mutationsList) {
            if (mutation.type === 'childList') {
              console.log(`ATC button changed.`)  
              // Assuming the price is always in a span with class 'discounted_price'
              var priceSpan = targetNode.querySelector('.discounted_price');
              var fullPriceSpan = targetNode.querySelector('.compare_price_cross');
              // console.log(`targetNode: `, targetNode)
              if (priceSpan) {
                var priceText = priceSpan.textContent;
                var fullPriceText = fullPriceSpan.textContent;
                // Now set this price to your subscription tab price

                // COMMENTED THESE OUT BECAUSE THEY SET THE PRICE INSTEAD OF THE PRICE PER BAG.
                // document.getElementById('subscription-tab-price').textContent = priceText;
                // document.getElementById('one-time-price').textContent = fullPriceText;

                console.log(`Price text: ${priceText}`);
                console.log(`Full price text: ${fullPriceText}`);

                //* Update the #subscription-tab-price span with the subscription price 
                // Extract the numeric part of the price string
                var numericPrice = priceText.replace(/[^\d.]/g, '');
                var subscribe_price_number = parseFloat(numericPrice);

                var loopFieldset = $('.loop-subscription-container:first .loop-selling-plan-fieldset');
                var selectedVariantId = loopFieldset.attr('data-selected-variant-id');

                // Find the span with the matching data-var-id attribute
                var selectedVariantSpan = document.querySelector(`span[data-var-id="${selectedVariantId}"]`);

                if (selectedVariantSpan) {
                  // Extract necessary data from the selected variant span
                  const selectedVariantServings = selectedVariantSpan.dataset['servings'];
                  // console.log(`Selected variant span: `, selectedVariantSpan);
                  // console.log(`Selected variant compare price: `, selectedVariantSpan.dataset['comparePrice'])

                  var pricePerBag;
                  var pricePerServingAfterLoopDiscount;

                  // Determine the pack size from the selectedVariantSpan
                  var packSize = determinePackSizeFromSpan(selectedVariantSpan);

                  // For subscription price (with discount)
                  pricePerBag = subscribe_price_number / packSize;
                  pricePerServingAfterLoopDiscount = subscribe_price_number / selectedVariantServings;

                  // Format the new price per serving with currency symbol and "/ serving"
                  var formattedPricePerServing =  `(${loopFormatMoney(pricePerServingAfterLoopDiscount * 100, false)} / serving)`;
                 

                  // Update the UI with the new formatted price per serving
                  $('#subscription-price-per-serving').text(formattedPricePerServing);

                  // Assuming pricePerBag needs to be converted back to cents as loopFormatMoney seems to expect a price in cents
                  var formattedPricePerBagWithDiscount = loopFormatMoney(pricePerBag * 100, false);

                  console.log(`Price per bag: ${pricePerBag}`);
                  console.log(`Price per bag with discount: ${formattedPricePerBagWithDiscount}`);
                  // Update the UI with the formatted price per bag with discount for subscription
                  // this keeps using the one-time price instead of the subscription price.
                  // $('#subscription-tab-price').text(formattedPricePerBagWithDiscount);

                  
                  if (selectedVariantSpan.dataset['comparePrice']) {
                    var originalPrice = parseFloat(selectedVariantSpan.dataset['price'].replace(/[^\d.]/g, ''));


                    // Determine the pack size from the selectedVariantSpan
                    var packSize = determinePackSizeFromSpan(selectedVariantSpan);



                    var pricePerBagWithoutDiscount = originalPrice / packSize;
                    pricePerServing = originalPrice / selectedVariantServings;
                    // var formattedPricePerServing = `(${pricePerServing.toFixed(2)} / serving)`;
                    var formattedPricePerServing = `(${loopFormatMoney(pricePerServing * 100, false)} / serving)`;
                    // Assuming pricePerBagWithoutDiscount needs to be converted back to cents as loopFormatMoney seems to expect a price in cents
                    var formattedPricePerBagWithoutDiscount = loopFormatMoney(pricePerBagWithoutDiscount * 100, false);

                    // console.log(`Price per bag without discount: ${formattedPricePerBagWithoutDiscount}`);

                    // Update the UI with the formatted price per bag without discount for one-time purchase
                    $('#one-time-price').text(formattedPricePerBagWithoutDiscount);
                    $('#one-time-price-per-serving').text(formattedPricePerServing);

                  }

                } else {
                  console.error('Selected variant span not found.');
                }


                // Disconnect the observer so we don't change the price multiple times.
                observer.disconnect();
                break;
              }
            }
          }
        };

        // Create an instance of the MutationObserver with the callback
        var observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);

      }

    }, 500);

      
    //product page subscription.
    $('.subscription-tab.custom-tab .tab input[type="radio"]').on('change', function () {
      $(this).parents('.tab').find('.tab-block').removeClass('selected');
      $(this).parents('.tab-block').addClass('selected');
      var id = $(this).attr('id');
      if (id.includes('subscribe')) {
        console.log(`Clicked subscribe tab`)

        $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label .pack_toggle_off.one_time').addClass('hidden');
        $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label .pack_toggle_off.subscribe').removeClass('hidden');
        $('.subscription-tab.custom-tab .subscribe-content').removeClass('hidden');
        $('.subscription-tab.custom-tab .onetime-content').addClass('hidden');
        if($('body').hasClass('template-product-ian-product-template')){
          $('.free-gift-text.one_time').addClass('hidden');
          $('.free-gift-text.subscription').removeClass('hidden');
        }

        $('.loop-subscription-container:first .loop-selling-plan-fieldset').find('.loop-product-subscribe').each(function (index) {
          var var_id = $(this).attr('data-var-id');

          var selling_price = $(this).find('.loop-subscription-group-price-container .loop-subscription-group-price-amount').attr('data-price');
          $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label .pack_toggle-content .pack-price[data-var-id="' + var_id + '"]').text(selling_price);

          if ($(this).css('display') == 'block') {
            //trigger app dropdown
            $(this).find('.loop-full-width').trigger('click');

            var frequency_html = $(this).find('.loop-subscription-group-selling-plans-container').html();
            if (frequency_html) {
              $('.subscription-tab.custom-tab .content .loop-frequency').html(frequency_html);
              $('.subscription-tab.custom-tab .content .loop-frequency').show();
            }

            var subscribe_price = $(this).find('.loop-subscription-group-price-container .loop-subscription-group-price-amount').attr('data-subscribe-price');
            var original_price = $(this).find('.loop-subscription-group-price-container .loop-subscription-group-price-amount').attr('data-original-price');
            $('.product-form__submit .price_text .discounted_price').text(subscribe_price);
            $('.product-form__submit .price_text .compare_price_cross').text(original_price);


            //* Update the #subscription-tab-price span with the subscription price 
            setTimeout(function () {
              // Extract the numeric part of the price string
              var numericPrice = subscribe_price.replace(/[^\d.]/g, '');
              var subscribe_price_number = parseFloat(numericPrice);

              var loopFieldset = $('.loop-subscription-container:first .loop-selling-plan-fieldset');
              var selectedVariantId = loopFieldset.attr('data-selected-variant-id');

              // Find the span with the matching data-var-id attribute
              var selectedVariantSpan = document.querySelector(`span[data-var-id="${selectedVariantId}"]`);

              if (!selectedVariantSpan) {
                console.error('Selected variant span not found.');
                return;
              }

              // Extract necessary data from the selected variant span
              const selectedVariantServings = selectedVariantSpan.dataset['servings'];
              // console.log(`Selected variant span: `, selectedVariantSpan);
              // console.log(`Selected variant compare price: `, selectedVariantSpan.dataset['comparePrice']);

              var packSize = determinePackSizeFromSpan(selectedVariantSpan);
              var pricePerBag = subscribe_price_number / packSize;
              var pricePerServingAfterLoopDiscount = subscribe_price_number / selectedVariantServings;

              updatePricingUI(pricePerBag, pricePerServingAfterLoopDiscount, selectedVariantSpan, 'subscription', 'subscription');

              if (selectedVariantSpan.dataset['comparePrice']) {
                var originalPrice = parseFloat(selectedVariantSpan.dataset['price'].replace(/[^\d.]/g, ''));
                // console.log(`Original price: ${originalPrice}`);

                var pricePerBagWithoutDiscount = originalPrice / packSize;
                var pricePerServingWithoutDiscount = originalPrice / selectedVariantServings;

                updatePricingUI(pricePerBagWithoutDiscount, pricePerServingWithoutDiscount, selectedVariantSpan, 'one-time', 'subscription');
              }
            }, 200);


          }
        });

      } else {
        $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label .pack_toggle_off.one_time').removeClass('hidden');
        $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label .pack_toggle_off.subscribe').addClass('hidden');
        $('.subscription-tab.custom-tab .subscribe-content').addClass('hidden');
        $('.subscription-tab.custom-tab .onetime-content').removeClass('hidden');

        if($('body').hasClass('template-product-ian-product-template')){
          $('.free-gift-text.one_time').removeClass('hidden');
          $('.free-gift-text.subscription').addClass('hidden');
        }

        $('.subscription-tab.custom-tab .content .loop-frequency').hide();
        $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label').each(function () {
          var ori_price = $(this).find('.pack-price:visible').attr('data-ori-price');
          $(this).find('.pack-price:visible').text(ori_price);
        });
          
             
        //trigger app dropdown
        setTimeout(function() {
          $('.loop-subscription-container:first .loop-selling-plan-fieldset .loop-one-time-purchase-option-position .loop-one-time-purchase-option').trigger('click');
        }, 300);

        var subscribe_price = $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options input[type="radio"]:checked').next('label').find('.pack-price:visible').attr('data-price');
        var original_price = $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options input[type="radio"]:checked').next('label').find('.pack-price:visible').attr('data-compare-price');
        $('.product-form__submit .price_text .discounted_price').text(subscribe_price);
        $('.product-form__submit .price_text .compare_price_cross').text(original_price);

                    //* Update the #subscription-tab-price span with the subscription price 
            setTimeout(function () {
              // Extract the numeric part of the price string
              var numericPrice = subscribe_price.replace(/[^\d.]/g, '');
              var subscribe_price_number = parseFloat(numericPrice);

              var loopFieldset = $('.loop-subscription-container:first .loop-selling-plan-fieldset');
              var selectedVariantId = loopFieldset.attr('data-selected-variant-id');

              // Find the span with the matching data-var-id attribute
              var selectedVariantSpan = document.querySelector(`span[data-var-id="${selectedVariantId}"]`);

              if (!selectedVariantSpan) {
                console.error('Selected variant span not found.');
                return;
              }

              // Extract necessary data from the selected variant span
              const selectedVariantServings = selectedVariantSpan.dataset['servings'];
              // console.log(`Selected variant span: `, selectedVariantSpan);
              // console.log(`Selected variant compare price: `, selectedVariantSpan.dataset['comparePrice']);

              var packSize = determinePackSizeFromSpan(selectedVariantSpan);
              var pricePerBag = subscribe_price_number / packSize;
              var pricePerServingAfterLoopDiscount = subscribe_price_number / selectedVariantServings;

              updatePricingUI(pricePerBag, pricePerServingAfterLoopDiscount, selectedVariantSpan, 'one-time', 'one-time');

              if (selectedVariantSpan.dataset['comparePrice']) {
                var originalPrice = parseFloat(selectedVariantSpan.dataset['price'].replace(/[^\d.]/g, ''));
                // console.log(`Original price: ${originalPrice}`);

                var pricePerBagWithoutDiscount = originalPrice / packSize;
                var pricePerServingWithoutDiscount = originalPrice / selectedVariantServings;

                updatePricingUI(pricePerBagWithoutDiscount, pricePerServingWithoutDiscount, selectedVariantSpan, 'one-time', 'one-time');
              }
            }, 200);

      }
    });

    $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label').on('click', function () {

      var sel_id = $('.subscription-tab.custom-tab .tab input[name="grp"]:checked').attr('id');
      // console.log(`Selected purchase type: `, sel_id)



      if (sel_id.includes('subscribe')) {

        setTimeout(function () {
          //trigger app dropdown
          $('.loop-subscription-container:first .loop-selling-plan-fieldset .loop-product-subscribe:visible .loop-full-width').trigger('click');
        }, 400);
        setTimeout(function () {

          $('.loop-subscription-container:first .loop-selling-plan-fieldset').find('.loop-product-subscribe').each(function (index) {
            if ($(this).css('display') == 'block') {
              var frequency_html = $(this).find('.loop-subscription-group-selling-plans-container').html();
              if (frequency_html) {
                $('.subscription-tab.custom-tab .content .loop-frequency').html(frequency_html);
                $('.subscription-tab.custom-tab .content .loop-frequency').show();
              }
              // console.log(`this: `, $(this))

              var subscribe_price = $(this).find('.loop-subscription-group-price-container .loop-subscription-group-price-amount').attr('data-subscribe-price');
              var original_price = $(this).find('.loop-subscription-group-price-container .loop-subscription-group-price-amount').attr('data-original-price');
              $('.product-form__submit .price_text .discounted_price').text(subscribe_price);
              $('.product-form__submit .price_text .compare_price_cross').text(original_price);




              //* Update the #subscription-tab-price span with the subscription price 
              setTimeout(function () {
                // Extract the numeric part of the price string
                var numericPrice = subscribe_price.replace(/[^\d.]/g, '');
                var subscribe_price_number = parseFloat(numericPrice);

                var loopFieldset = $('.loop-subscription-container:first .loop-selling-plan-fieldset');
                var selectedVariantId = loopFieldset.attr('data-selected-variant-id');

                // Find the span with the matching data-var-id attribute
                var selectedVariantSpan = document.querySelector(`span[data-var-id="${selectedVariantId}"]`);

                if (!selectedVariantSpan) {
                  console.error('Selected variant span not found.');
                  return;
                }

                // Extract necessary data from the selected variant span
                const selectedVariantServings = selectedVariantSpan.dataset['servings'];
                // console.log(`Selected variant span: `, selectedVariantSpan);
                // console.log(`Selected variant compare price: `, selectedVariantSpan.dataset['comparePrice']);

                var packSize = determinePackSizeFromSpan(selectedVariantSpan);
                var pricePerBag = subscribe_price_number / packSize;
                var pricePerServingAfterLoopDiscount = subscribe_price_number / selectedVariantServings;

                updatePricingUI(pricePerBag, pricePerServingAfterLoopDiscount, selectedVariantSpan, 'subscription', 'subscription');

                if (selectedVariantSpan.dataset['comparePrice']) {
                  var originalPrice = parseFloat(selectedVariantSpan.dataset['price'].replace(/[^\d.]/g, ''));
                  // console.log(`Original price: ${originalPrice}`);

                  var pricePerBagWithoutDiscount = originalPrice / packSize;
                  var pricePerServingWithoutDiscount = originalPrice / selectedVariantServings;

                  //! Commented this out because it was causing problems
                  // updatePricingUI(pricePerBagWithoutDiscount, pricePerServingWithoutDiscount, selectedVariantSpan, 'one-time', 'subscription');
                }
              }, 200);




              // You'll need to define or adjust the determinePackSizeFromSpan function based on how you can infer the pack size from the selectedVariantSpan or related
              // console.log('subscribe_price', subscribe_price);
              // $('#subscription-tab-price').text(subscribe_price);
            }
          });
          // var frequency_html = $('.loop-subscription-container:first .loop-selling-plan-fieldset').find('.loop-product-subscribe:visible').find('.loop-subscription-group-selling-plans-container').html();
          // if(frequency_html){
          //   $('.subscription-tab.custom-tab .content .loop-frequency').html(frequency_html);
          //   $('.subscription-tab.custom-tab .content .loop-frequency').show();
          // }
        }, 200);
      } else {

        //* One-Time tab is selected and a variant is selected. Update the subscription tab price and one time tab price
        setTimeout(function () {
          console.log(`One-Time tab is selected and a variant was selected.`)
          // Extract the numeric part of the price string
          var numericPrice = subscribe_price.replace(/[^\d.]/g, '');
          var subscribe_price_number = parseFloat(numericPrice);

          var loopFieldset = $('.loop-subscription-container:first .loop-selling-plan-fieldset');
          var selectedVariantId = loopFieldset.attr('data-selected-variant-id');

          // Find the span with the matching data-var-id attribute
          var selectedVariantSpan = document.querySelector(`span[data-var-id="${selectedVariantId}"]`);

          if (!selectedVariantSpan) {
            console.error('Selected variant span not found.');
            return;
          }

          // Extract necessary data from the selected variant span
          const selectedVariantServings = selectedVariantSpan.dataset['servings'];
          // console.log(`Selected variant span: `, selectedVariantSpan);
          // console.log(`Selected variant compare price: `, selectedVariantSpan.dataset['comparePrice']);

          //get the discounted price from loop. (sellingplanpriceadjustments)
          const sellingPlanPriceAdjustment = window.loopProps["8752779362643"].sellingPlanPriceAdjustments[0];
          console.log(`sellingPlanPriceAdjustment: `, sellingPlanPriceAdjustment);

          var packSize = determinePackSizeFromSpan(selectedVariantSpan);
          var pricePerBag = subscribe_price_number / packSize;
          var pricePerServingAfterLoopDiscount = subscribe_price_number / selectedVariantServings;

          //! Commented this out because it's not necessary to update the subscription price when the one-time tab is selected
          // updatePricingUI(pricePerBag, pricePerServingAfterLoopDiscount, selectedVariantSpan, 'subscription', 'one-time');

          if (selectedVariantSpan.dataset['comparePrice']) {
            var originalPrice = parseFloat(selectedVariantSpan.dataset['price'].replace(/[^\d.]/g, ''));
            console.log(`Original price: ${originalPrice}`);

            var pricePerBagWithoutDiscount = originalPrice / packSize;
            var pricePerServingWithoutDiscount = originalPrice / selectedVariantServings;

            updatePricingUI(pricePerBagWithoutDiscount, pricePerServingWithoutDiscount, selectedVariantSpan, 'one-time',  'one-time');
          }
        }, 200);


        $('.subscription-tab.custom-tab .content .loop-frequency').hide();
        setTimeout(function () {
          //trigger app dropdown
          $('.loop-subscription-container:first .loop-selling-plan-fieldset .loop-one-time-purchase-option-position .loop-one-time-purchase-option').trigger('click');
        }, 400);

        var subscribe_price = $(this).find('.pack-price:visible').attr('data-price');
        var original_price = $(this).find('.pack-price:visible').attr('data-compare-price');
        // console.log(`Subscribe price: ${subscribe_price}`);
        // console.log(`Original price: ${original_price}`);




        $('.product-form__submit .price_text .discounted_price').text(subscribe_price);
        $('.product-form__submit .price_text .compare_price_cross').text(original_price);
      }

    });


    var isALARendered;
    function ALAcheck() {
      isALARendered = setInterval(function () {
        customALA()
      }, 400);
    }
    ALAcheck();
    function customALA() {
      var selector = $('.loop-subscription-container:first .loop-selling-plan-fieldset');
      if (selector.length > 0) {
        clearInterval(isALARendered);
        // var val = $(selector).attr('data-selling-plan-group-id');
         var val = $('.loop-subscription-container:first .loop-selling-plan-fieldset').attr('data-selling-plan-group-id');
        console.log('Selling plan group id from Loop fieldset: ', val);
        if (!val.includes('one-time-purchase')) {

          

          $('.subscription-tab.custom-tab .subscribe-content').removeClass('hidden');
          $('.subscription-tab.custom-tab .onetime-content').addClass('hidden');
          $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label .pack_toggle_off.one_time').addClass('hidden');
          $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label .pack_toggle_off.subscribe').removeClass('hidden');
          $('.subscription-tab.custom-tab .tab').find('.tab-block:first').addClass('active');

          if($('body').hasClass('template-product-ian-product-template')){
            $('.free-gift-text.one_time').addClass('hidden');
            $('.free-gift-text.subscription').removeClass('hidden');
          }

          $(selector).find('.loop-product-subscribe').each(function (index) {
            var var_id = $(this).attr('data-var-id');
            var selling_price = $(this).find('.loop-subscription-group-price-container .loop-subscription-group-price-amount').attr('data-price');

            $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label .pack_toggle-content .pack-price[data-var-id="' + var_id + '"]').text(selling_price);
            // console.log('In subscription tab, i think: selling_price', selling_price);
          });
          setTimeout(function () {
            
            // var frequency_html = $('.loop-subscription-container:first .loop-selling-plan-fieldset').find('.loop-product-subscribe:visible').find('.loop-subscription-group-selling-plans-container').html();
            // if(frequency_html){
            //   $('.subscription-tab.custom-tab .content .loop-frequency').html(frequency_html);
            //   $('.subscription-tab.custom-tab .content .loop-frequency').show();
            // }
            $('.loop-subscription-container:first .loop-selling-plan-fieldset').find('.loop-product-subscribe').each(function (index) {
              if ($(this).css('display') == 'block') {
                var frequency_html = $(this).find('.loop-subscription-group-selling-plans-container').html();
                if (frequency_html) {
                  $('.subscription-tab.custom-tab .content .loop-frequency').html(frequency_html);
                  $('.subscription-tab.custom-tab .content .loop-frequency').show();
                }

                var subscribe_price = $(this).find('.loop-subscription-group-price-container .loop-subscription-group-price-amount').attr('data-subscribe-price');
                var original_price = $(this).find('.loop-subscription-group-price-container .loop-subscription-group-price-amount').attr('data-original-price');
                $('.product-form__submit .price_text .discounted_price').text(subscribe_price);
                $('.product-form__submit .price_text .compare_price_cross').text(original_price);

                /* Update the #subscription-tab-price span with the subscription price */
                // console.log(`In customALA:: Updating subscription tab with subscribe price: ${subscribe_price}`);
                // $('#subscription-tab-price').text(subscribe_price)

                  //* Update the #subscription-tab-price span with the subscription price 
                  setTimeout(function () {
                    // Extract the numeric part of the price string
                    var numericPrice = subscribe_price.replace(/[^\d.]/g, '');
                    var subscribe_price_number = parseFloat(numericPrice);
      
                    var loopFieldset = $('.loop-subscription-container:first .loop-selling-plan-fieldset');
                    var selectedVariantId = loopFieldset.attr('data-selected-variant-id');
      
                    // Find the span with the matching data-var-id attribute
                    var selectedVariantSpan = document.querySelector(`span[data-var-id="${selectedVariantId}"]`);
      
                    if (!selectedVariantSpan) {
                      console.error('Selected variant span not found.');
                      return;
                    }
      
                    // Extract necessary data from the selected variant span
                    const selectedVariantServings = selectedVariantSpan.dataset['servings'];
                    // console.log(`Selected variant span: `, selectedVariantSpan);
                    // console.log(`Selected variant compare price: `, selectedVariantSpan.dataset['comparePrice']);
      
                    var packSize = determinePackSizeFromSpan(selectedVariantSpan);
                    var pricePerBag = subscribe_price_number / packSize;
                    var pricePerServingAfterLoopDiscount = subscribe_price_number / selectedVariantServings;
      
                    updatePricingUI(pricePerBag, pricePerServingAfterLoopDiscount, selectedVariantSpan, 'subscription', 'subscription');
      
                    if (selectedVariantSpan.dataset['comparePrice']) {
                      var originalPrice = parseFloat(selectedVariantSpan.dataset['price'].replace(/[^\d.]/g, ''));
                      // console.log(`Original price: ${originalPrice}`);
      
                      var pricePerBagWithoutDiscount = originalPrice / packSize;
                      var pricePerServingWithoutDiscount = originalPrice / selectedVariantServings;
      
                      updatePricingUI(pricePerBagWithoutDiscount, pricePerServingWithoutDiscount, selectedVariantSpan, 'one-time', 'subscription');
                    }
                  }, 200);

                
              }
            });
          }, 800);
        } else {

          $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label .pack_toggle_off.one_time').removeClass('hidden');
          $('.subscription-tab.custom-tab variant-radios fieldset.subscription-product-options label .pack_toggle_off.subscribe').addClass('hidden');
          $('.subscription-tab.custom-tab .subscribe-content').addClass('hidden');
          $('.subscription-tab.custom-tab .onetime-content').removeClass('hidden');
          $('.subscription-tab.custom-tab .content .loop-frequency').hide();

          if($('body').hasClass('template-product-ian-product-template')){
            $('.free-gift-text.one_time').removeClass('hidden');
            $('.free-gift-text.subscription').addClass('hidden');
          }

          var subscribe_price = $(selector).find('.loop-one-time-purchase-option-position .loop-one-time-purchase-option-price-container .loop-one-time-purchase-option-price-amount').attr('data-ori_price');
          var original_price = $(selector).find('.loop-one-time-purchase-option-position .loop-one-time-purchase-option-price-container .loop-one-time-purchase-option-price-amountt').attr('data-compare-price');
          $('.product-form__submit .price_text .discounted_price').text(subscribe_price);
          $('.product-form__submit .price_text .compare_price_cross').text(original_price);
        }
      }
    }
  }
  }
});

// contct form js
$(".contact .main_dropdown").change(function () {
  $(".main_dropdown option.not_usable").remove();
  var selected_val = $(this).val();
  // $(".sub-field").addClass("hidden");
  // $(".wrp-form-sub-field .sub-field").each(function (index) {
  //   if ($(this).hasClass(selected_val)) {
  //     $(this).removeClass("hidden");
  //     $(".append-field").empty().append(this)
  //   }
  // });
  $(".append-field .field").addClass("hidden");
  $(`.append-field .field.${selected_val}`).removeClass("hidden");
});

// $(".sub-field select").change(function () {
//   $(".sub-field").each(function (index) {
//     if ($(this).hasClass("hidden") == false) {
//       $(this).find(".not_usable").remove();
//     }
//   });
// });

//swiper slider
var swiper = new Swiper(".image-slider", {
  slidesPerView: 1,
  slidesPerGroup: 1,
  spaceBetween: 8,
  grabCursor: true,
  loop: false,
  breakpoints: {
    576: {
      slidesPerView: 2,
      slidesPerGroup: 1,
      spaceBetween: 8,
    },
    750: {
      slidesPerView: 2,
      slidesPerGroup: 1,
    },
    990: {
      slidesPerView: 3,
      slidesPerGroup: 1,
      spaceBetween: 30,
    },
    1200: {
      slidesPerView: 4,
      slidesPerGroup: 1,
      spaceBetween: 30,
    },
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

//testimonial slider
var swiper_slider = new Swiper(".testimonial-slider", {
  slidesPerView: 1,
  grabCursor: true,
  spaceBetween: 10,
  breakpoints: {
    750: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 20,
    },
    990: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 20,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
// ann bar slider
var swiper_slider = new Swiper('.ann_slider .swiper', {
  // Optional parameters
  direction: 'horizontal',
  slidesPerView: 1,
  loop: true,
  autoplay: {
    delay: 10000,
  },
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
//Home page testimonial slider
var swiper_slider = new Swiper(".testimonial-slider-2", {
  slidesPerView: 1,
  slidesPerGroup: 1,
  grabCursor: true,
  spaceBetween: 35,
  breakpoints: {
    576: {
      slidesPerView: 2,
      slidesPerGroup: 1,
    },
    990: {
      slidesPerView: 3,
      slidesPerGroup: 1,
    },
  },
  navigation: {
    nextEl: ".testimonial2-inner .swiper-button-next",
    prevEl: ".testimonial2-inner .swiper-button-prev",
  },
});

//Shop all page testimonial slider
var swiper_slider = new Swiper(".testimonial-slider-3", {
  slidesPerView: 1,
  slidesPerGroup: 1,
  grabCursor: true,
  spaceBetween: 30,
  loop: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false
  },
  breakpoints: {
    750: {
      slidesPerView: 2,
      slidesPerGroup: 1,
    },
    990: {
      slidesPerView: 3,
      slidesPerGroup: 1,
    },
  },
  pagination: {
    el: ".testimonial3-inner .swiper-pagination",
  },
  navigation: {
    nextEl: ".testimonial3-inner .swiper-button-next",
    prevEl: ".testimonial3-inner .swiper-button-prev",
  },
});

//ingredient slider
var swiper_slider = new Swiper(".ingredient-slider", {
  slidesPerView: 1,
  slidesPerGroup: 1,
  grabCursor: true,
  spaceBetween: 20,
  breakpoints: {
    750: {
      slidesPerView: 2,
      slidesPerGroup: 1,
    },
    990: {
      slidesPerView: 3,
      slidesPerGroup: 1,
    },
    1200: {
      slidesPerView: 4,
      slidesPerGroup: 1,
    },
    1300: {
      slidesPerView: 5,
      slidesPerGroup: 1,
    },
    1500: {
      slidesPerView: 6,
      slidesPerGroup: 1,
    },
  },
  pagination: {
    el: ".ingredient-slider-inner .swiper-pagination",
  },
});

//Home page customer upper slider
var swiper_slider = new Swiper(".cust-upper-slider", {
  slidesPerView: 4,
  slidesPerGroup: 1,
  centeredSlides: false,
  grabCursor: true,
  spaceBetween: 8,
  loop: true,
  breakpoints: {
    990: {
      slidesPerView: 3.5,
      slidesPerGroup: 1,
      centeredSlides: false,
      spaceBetween: 16,
    },
  },
});

//Home page customer lower slider
var swiper_slider = new Swiper(".cust-lower-slider", {
  slidesPerView: 3.5,
  slidesPerGroup: 1,
  centeredSlides: true,
  grabCursor: true,
  spaceBetween: 16,
  loop: true,
});

// PDP info text slider
const getattr = document.querySelectorAll('[data-slider-id]');
if (getattr) {
getattr.forEach(block => {
  const sliderEl     = block.querySelector('.product__info-wrapper .pdp-info-text-slider');
  const paginationEl = block.querySelector('.text-slider .swiper-pagination');

  new Swiper(sliderEl, {         
    slidesPerView: 1,
    slidesPerGroup: 1,
    grabCursor: true,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    pagination: {
      el: paginationEl            
    }
  });
});
}



//Home page video slider
var swiper_slider = new Swiper(".section-video-slider .video-slider", {
  slidesPerView: 2,
  slidesPerGroup: 1,
  grabCursor: true,
  loop: true,
  paginationClickable: true,
  spaceBetween: 8,
  breakpoints: {
    750: {
      slidesPerView: 3,
      slidesPerGroup: 1,
    },
    990: {
      slidesPerView: 5,
      slidesPerGroup: 1,
      spaceBetween: 10,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

//PDP page video slider
var swiper_slider = new Swiper(".section-pdp-video-slider .pdp-video-slider", {
  slidesPerView: 1.25,
  slidesPerGroup: 1,
  grabCursor: true,
  loop: true,
  paginationClickable: true,
  spaceBetween: 20,
  breakpoints: {
    750: {
      slidesPerView: 3,
      slidesPerGroup: 1,
      spaceBetween: 20,
    },
    990: {
      slidesPerView: 5,
      slidesPerGroup: 1,
      spaceBetween: 20,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

//  Marquee Section
var swiper_slider = new Swiper(".marquee-text .marquee-swiper", {
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    speed: 10000,
    autoplay: {
        delay: 0,
        disableOnInteraction: false
    },
    loop: true,
    allowTouchMove: false
});

//Review tab slider
var swiper_slider = new Swiper(".review-tab-slider", {
  slidesPerView: 1.1,
  grabCursor: true,
  spaceBetween: 30,
  centeredSlides: true,
  loop: true,
  breakpoints: {
    0: {
      slidesPerView: 1.2,
      spaceBetween: 15,
    },
    750: {
      slidesPerView: 1.2,
      spaceBetween: 15,
    },
    990: {
      slidesPerView: 1.3,
    },
    1200: {
      slidesPerView: 1.5,
    },
    1400: {
      slidesPerView: 1.9,
    },
  },
  navigation: {
    nextEl: ".review-tab .swiper-button-next",
    prevEl: ".review-tab .swiper-button-prev",
  },
});



//Home page unlike slider
let unlike_slider;
let premium_ingredient_slider;

function initSwiper() {
  // Destroy if already initialized
  if (unlike_slider) unlike_slider.destroy(true, true);

  unlike_slider = new Swiper(".unlike-any-other .unlike-slider", {
    slidesPerView: 1.5,
    slidesPerGroup: 1,
    initialSlide: 1,
    centeredSlides: true,
    grabCursor: true,
    loop: true,
    spaceBetween: 16,
    breakpoints: {
      750: {
        slidesPerView: 3,
        grabCursor: false,
        loop: false,
        centeredSlides: false,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

   if (premium_ingredient_slider) premium_ingredient_slider.destroy(true, true);
  
  premium_ingredient_slider = new Swiper(".premium-ingredient .premium-ingredient-slider", {
    slidesPerView: 1.2,
    slidesPerGroup: 1,
    centeredSlides: true,
    loop: true,
    grid: {
      rows: 1,
      fill: "row",
    },
    spaceBetween: 15,
    breakpoints: {
      750: {
        slidesPerView: 2,
        grabCursor: false,
        spaceBetween: 24,
        centeredSlides: false,
        loop: false,
        grid: {
          rows: 3,
        },
      },
      1101: {
        slidesPerView: 3,
        grabCursor: false,
        spaceBetween: 24,
        centeredSlides: false,
        loop: false,
        grid: {
          rows: 3,
        },
      }
    }
  });
}

// Initialize on load
initSwiper();

let resizeTimeout;
window.addEventListener('resize', function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    initSwiper();
  }, 300); // debounce to avoid excessive calls
});
  
    supplement_slider = new Swiper(".section-supplement .supplement-slider", {
    slidesPerView: 1.2,
    slidesPerGroup: 1,
    centeredSlides: true,
    loop: true,
    grid: {
      rows: 1,
      fill: "row",
    },
    spaceBetween: 15,
    breakpoints: {
      750: {
        slidesPerView: 2,
        grabCursor: false,
        spaceBetween: 24,
        centeredSlides: false,
        loop: false,
        grid: {
          rows: 2,
        },
      },
      1101: {
        slidesPerView: 3,
        grabCursor: false,
        spaceBetween: 24,
        centeredSlides: false,
        loop: false,
        grid: {
          rows: 2,
        },
      }
    }
  });


    testimonials_4 = new Swiper(".testimonials-4 .testimonials-4-slider", {
    slidesPerView: 1.3,
    slidesPerGroup: 1,
    centeredSlides: true,
    loop: true,
    spaceBetween: 15,
    breakpoints: {
      750:{
        slidesPerView: 2.3,
      },
      989:{
        slidesPerView: 3,
      }
    }
  });




   expert_review_slider = new Swiper(".section-expert-review .expert-review-slider", {
    slidesPerView: 1,
    slidesPerGroup: 1,
    centeredSlides: false,
    loop: true,
    spaceBetween: 15,
    navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
    breakpoints: {
   
      0: {
        slidesPerView: 1.2,
        spaceBetween: 20,
        loop: true,
        centeredSlides: true,
      },
      750: {
        slidesPerView: 2.3,
        spaceBetween: 20,
        loop: false,
      },
      990: {
        slidesPerView: 3,
        spaceBetween: 20,
        loop: false,
      }
    }
  });


// $(document).on("click",".section-video-slider .video-slider-item",function(e){
//   e.preventDefault();
//   if($(this).find("iframe").length){
//     let iframe = $(this).find("iframe");
//     let originalSrc = iframe.attr("data-src");
//     // console.log("iframe",iframe.attr("src"));
//     if(iframe.attr("src").includes("autoplay=1")){
//       let src = originalSrc + `&autoplay=0`;
//       // iframe.removeAttr("src");
//       iframe.attr("src",src);
//     }else{
//       let src = originalSrc + `&autoplay=1`;
//       // iframe.removeAttr("src");
//       iframe.attr("src",src);
//     }

//   }else{
//     // video tag
//     let video = $(this).find("video")[0];
//     if(video.paused){
//       video.play();
//       $(this).addClass("video-play");
//     }else{
//       video.pause();
//       $(this).removeClass("video-play");
//     }
//   }
// });

$(".section-video-slider .play-icon").click(function () {
  $(this).siblings("video").trigger("play");
  $(this).siblings("video").attr("loop", "true");
  $(this).hide();
  $(this).siblings(".pause-icon").css("display", "flex");
  $(this)
    .siblings("video")
    .closest(".video-slider-item")
    .addClass("play_video");
});
$(".section-video-slider .pause-icon").click(function () {
  $(this).siblings("video").trigger("pause");
  $(this).hide();
  $(this).siblings(".play-icon").show();
  $(this)
    .siblings("video")
    .closest(".video-slider-item")
    .removeClass("play_video");
});

$(document).ready(function () {
  // $(window).on('scroll touchmove', function () {
  //   var sticky_cart = $(".sticky-add-btn");
  //   var scroll_section = $(window).scrollTop();
  //   // var section_height = $0(".product__info-container").outerHeight();
  //   var section_height = 1000;
  //   if (scroll_section > section_height) { sticky_cart.addClass("visible") } else { sticky_cart.removeClass("visible") }
  // });

  const sticky_btn = document.querySelector('.sticky-add-btn');
  const original_btn = document.querySelector('.product-form__buttons .product-form__submit');
  
  if (sticky_btn && original_btn) {
      const originalPosition = original_btn.getBoundingClientRect().top + window.scrollY;
  
      const checkPosition = () => {
          const scrollTop = window.scrollY || document.documentElement.scrollTop;
  
          // If the scroll position is greater than or equal to the original button's position, show the sticky button
          if (scrollTop >= originalPosition) {
              sticky_btn.classList.add('visible');
          } 
          // Hide the sticky button when the original button is visible (when scrolling back up)
          else {
              sticky_btn.classList.remove('visible');
          }
      };
  
      // Listen for scroll and touchmove events
      window.addEventListener('scroll', checkPosition);
      window.addEventListener('touchmove', checkPosition);
  }


  // $(".btn__add-to-cart .button").click(function () {
  //   $(".product-form__buttons .button").click();
  //   return false;
  // });

  // image popup
  $(
    ".viewall-btn, .product-ingredient-action-wrapper .custom_btn, .mobileproduct-ingredient-content .custom_btn, .section-image-with-blocks .popup--button"
  ).click(function () {
    $(".ingredient-model").fadeIn();
    $("body").addClass("overflow-hidden");
  });

  $(".close").click(function () {
    $(".ingredient-model").fadeOut();
    $("body").removeClass("overflow-hidden");
  });
});

// Fixed Try it button
var $logo = $(".fixed-button");
$(document).scroll(function () {
  if ($(this).scrollTop() > 300) {
    $(".fixed-button").css("display", "block");
  } else {
    $(".fixed-button").css("display", "none");
  }
});

$(document).ready(function () {
  //  Tab js for FAQ page
  $(".wrp_nav li").click(function () {
    var width = $(window).width();
    $(".wrp_nav li").removeClass("active");
    $(this).addClass("active");
    $(".tab_content").hide();
    var activeTab = $(this).attr("data-title");
    $("#" + activeTab).fadeIn();
    if (width < 990) {
      $('html, body').animate({
        scrollTop: $("#" + activeTab).offset().top
      }, 1000);
    }
    return false;
  });
  // Accordion js
  // $(".wrp_accordion:nth-child(1) h4").addClass("active");
  // $(".wrp_accordion:nth-child(1) .content").slideDown();
  $(".wrp_accordion h4").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).siblings(".content").slideUp();
      $(this).removeClass("active");
    } else {
      $(".content").slideUp();
      $(".wrp_accordion h4").removeClass("active");
      $(this).siblings(".content").slideToggle();
      $(this).toggleClass("active");
    }
  });

  // Product reference toggle
  $(".product--Reference-Toggle").click(function () {
    $(".product--Reference-Content").slideToggle();
    $('.product--Reference-Toggle').toggleClass("active");
  });
});


// manu drawer close button
$('.close-drawer').on('click', function () {
  $('.header__icon--menu').trigger('click');
});

// var customBtn = document.querySelector(".custom_add .freePDpbtn");
// if(customBtn){
//   customBtn.addEventListener('click',function(){
//      var freePdpJson = JSON.parse(customBtn.getAttribute("freepdpjson"));
//      var timeStamp = document.querySelector("#time_stamp").value;
//     const arr = [];

//     // freePdpJson.forEach(item => {
//     //   // Push the formatted object to the array
//     //   arr.push({ id: item.product_id, quantity: 1 ,properties:{'time_stamp':timeStamp}});
//     // });
    
//     for (let i = freePdpJson.length - 1; i >= 0; i--) {
//       const item = freePdpJson[i];
//       // Push the formatted object to the array
//       arr.push({ id: item.product_id, quantity: 1, properties: { 'time_stamp': timeStamp } });
//     }

//       console.log("array",arr);
//      // console.log("formData",formData);
//      var sections = ['cart-drawer', 'cart-icon-bubble'];
//         fetch('/cart/add.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           body: JSON.stringify({
// 							items:arr,
// 							sections: sections
// 						}),
//         })
//         .then(response => response.json())
//         .then(response =>  {
//           // document.querySelector(".product-form__submit").click();
//           const cartDrawer = document.querySelector('cart-drawer');
//           // return false;
//           cartDrawer.classList.remove('is-empty');          
//           cartDrawer.renderContents(response);
//         })
//   });
// }



//pro button
var pro_submit_btn = document.querySelector(".product-form__buttons .product-form__submit");
if(pro_submit_btn){
  pro_submit_btn.addEventListener('click',function(event){
    var customBtn = document.querySelector(".custom_add .freePDpbtn");
    
      if(customBtn){
        event.preventDefault();
        pro_submit_btn.classList.add('loading');
        pro_submit_btn.querySelector('.loading__spinner').classList.remove('hidden');

        var freePdpJson = JSON.parse(customBtn.getAttribute("freepdpjson"));
        var customBtn = document.querySelector(".custom_add .freePDpbtn");
        var gift_length = $('.free-gift-block .free-gift-products .product-box.active').length;
        console.log(gift_length);
        console.log(freePdpJson.length);
          
        // var timeStamp = document.querySelector("#time_stamp").value;
        var timeStamp = Math.round(new Date().getTime()/1000);
        const arr = [];

        var main_pro_id = document.querySelector('[name="id"]').value;
        var selling_plan = document.querySelector('[name="selling_plan"]').value;
    
        // freePdpJson.forEach(item => {
        //   // Push the formatted object to the array
        //   arr.push({ id: item.product_id, quantity: 1 ,properties:{'time_stamp':timeStamp}});
        // });

        // Initialize the array to store the items
        // for (let i = freePdpJson.length - 1; i >= freePdpJson.length - gift_length && i >= 0; i--) {
        //   const item = freePdpJson[i];
        //   arr.push({
        //     id: item.product_id,
        //     quantity: 1,
        //     properties: { '_time_stamp': timeStamp, '_free_product': 'yes' }
        //   });
        // }
        for (let i = 0; i < gift_length && i < freePdpJson.length; i++) {
          const item = freePdpJson[i];
          arr.unshift({ // Use unshift to add items to the beginning of the array
            id: item.product_id,
            quantity: 1,
            properties: { '_time_stamp': timeStamp, '_free_product': 'yes' }
          });
        }
        
        // for (let i = freePdpJson.length - 1; i >= 0; i--) {
        //   const item = freePdpJson[i];
        //   // Push the formatted object to the array
        //   arr.push({ id: item.product_id, quantity: 1, properties: { '_time_stamp': timeStamp,'_free_product':'yes' } });
        // }

        if(main_pro_id){
          if(selling_plan){
            arr.push({ id: main_pro_id, quantity: 1,selling_plan:selling_plan, properties: { '_time_stamp': timeStamp } });
          }else{
            arr.push({ id: main_pro_id, quantity: 1, properties: { '_time_stamp': timeStamp } });
          }
        }
    
          // console.log("array",arr);
         // console.log("formData",formData);
         var sections = ['cart-drawer', 'cart-icon-bubble'];
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
    							items:arr,
    							sections: sections
    						}),
            })
            .then(response => response.json())
            .then(response =>  {
              // document.querySelector(".product-form__submit").click();
              const cartDrawer = document.querySelector('cart-drawer');
              // return false;
              cartDrawer.classList.remove('is-empty');          
              cartDrawer.renderContents(response);
              pro_submit_btn.classList.remove('loading');
              pro_submit_btn.querySelector('.loading__spinner').classList.add('hidden');

              var time = document.querySelector('cart-drawer').getAttribute('data-timer');
              window.cart_limit = time * 60 * 1000;

              var shipping_switch = document.querySelector('cart-drawer .shipping-protection');
              if(shipping_switch){
                var switch_check = shipping_switch.querySelector('#shipping-protection-switch-input');
                if(!switch_check.checked){
                  switch_check.checked = true;
                  switch_check.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
              
            })
        
        return false;
      }else{
        return true;
      }
  });
}


//policy popup
$(document).on('click','product-form .policy-text,.shipping-policy-item.policy-open-popup,.PDP-main-title .rich-text__blocks .policy-text',function(){
  $('.policy-popup').addClass('popup-open');
  $('body').addClass('popup-overflow');
});
$(document).on('click','.policy-popup .close-policy-popup',function(){
  $('.policy-popup').removeClass('popup-open');
  $('body').removeClass('popup-overflow');
});

$(document).mouseup(function(e){
  var container = $(".policy-popup-inner");
  // if the target of the click isn't the container nor a descendant of the container
  
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.policy-popup').removeClass('popup-open');
        $('body').removeClass('popup-overflow');
    }
});


// i information popup
$(document).on('click','.information_popup_btn',function(){
  $('.pdp-infomation-popup').addClass('popup-open');
  $('body').addClass('popup-overflow');
});
$(document).on('click','.pdp-infomation-popup .close-pdp-infomation-popup',function(){
  $('.pdp-infomation-popup').removeClass('popup-open');
  $('body').removeClass('popup-overflow');
});

$(document).mouseup(function(e){
  var container = $(".pdp-infomation-popup-inner");
  // if the target of the click isn't the container nor a descendant of the container
  
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.pdp-infomation-popup').removeClass('popup-open');
        $('body').removeClass('popup-overflow');
    }
});
//End i information popup



$(document).ready(function () {
  $(document).on('click','cart-drawer .drawer__inner .cart-items .cart-item .cart-item__details .variant_tooltip, .main-cart-items .cart-item__details .variant_tooltip',function(){
    $(this).parents('.cart-item__details').find('.variant-box').addClass('active');
  });
  $(document).on('click','cart-drawer .drawer__inner .cart-items .cart-item .cart-item__details .variant-box .close-tooltip, .main-cart-items .cart-item__details .tooltip-box .close-tooltip',function(){
    $(this).parents('.variant-box').removeClass('active');
  });

  $(document).mouseup(function(e){
    var container = $(".variant-box");
    // if the target of the click isn't the container nor a descendant of the container
    
      if (!container.is(e.target) && container.has(e.target).length === 0) {
          $(container).removeClass('active');
          // $('body').removeClass('popup-overflow');
      }
  });
  // $('cart-drawer .drawer__inner .cart-items .cart-item .cart-item__details .variant_tooltip')

      //Ak custom code
     //shipping_on_off_switch
      $(document).on('change','.shipping-protection #shipping-protection-switch-input',function(){
      // $('.shipping-protection #shipping-protection-switch-input').change(function() {
        var pro_var_id = $(this).val();
        if(this.checked) {
          console.log('hiii');
            if(pro_var_id){
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data : {
                    "id": pro_var_id,
                    "quantity": 1
                  },
                  dataType: 'json',
                  success: function(response) {   
  
                    // add_free_gift_also();
                    const this_cartDrawer = document.querySelector('cart-drawer');
                    this_cartDrawer.refresh(true);                
                  },
                  error: function(response) { 
                  console.log("error-add", response)              
                  } 
                
                });
            }
        }else{
          jQuery.getJSON('/cart.js', function(cart) {
            let cartData = cart.items;
            if(cartData.length > 0){
               
              for(var i=0;i<cartData.length;i++){
                if(cartData[i].id == pro_var_id){
                    var updates = {
                      updates: {}
                    };

                    updates['updates'][pro_var_id] = 0;

                    $.ajax({
                      url: "/cart/update.js",
                      type: "POST",
                      data: updates,
                      dataType: "json",
                      success: function (response) {
                        console.log('success remove')
                        if($('body').hasClass('template-cart')){
                          location.reload();
                        }else{
                          const this_cartDrawer = document.querySelector('cart-drawer');
                          this_cartDrawer.refresh(true,response.item_count);
                        }
                      },
                      error: function(error){
                        console.log('not  remove')
                      }
                    });

                }
              }
            }
          });
          
        }
      });

    //for gift products popup
 //  $('.product-box .image-popup-fit-width').magnificPopup({
	// 	type: 'image',
	// 	closeOnContentClick: true,
	// 	image: {
	// 		verticalFit: false
	// 	}
	// });
   // Attach a click event to the product image
    $('.product-image.image-popup-fit-width').on('click', function() {
        // Get the image source and price from data attributes
        var imgSrc = $(this).data('img-src');
        var price = $(this).data('price');

        // Create the content for the Magnific Popup
        var content = `
            <div class="popup-content">
                <img src="${imgSrc}" alt="Gift Image" class="popup-image">
                <div class="popup-price">
                    <span>${price}</span>
                </div>
            </div>
        `;

        // Open Magnific Popup with the content
        $.magnificPopup.open({
            items: {
                src: content,
                type: 'inline'
            },
            closeBtnInside: true, // Close button inside the popup
            midClick: true, // Allow opening popup on middle click
        });
    });


  // if(document.body.classList.contains('template-product')){
  //   let autoClickInterval;
  //   let userInteracted = false;
    
  //   const rightBtn = document.querySelector('.media-gallery-inner slider-component .slider-button--next');
  //   const leftBtn = document.querySelector('.media-gallery-inner slider-component .slider-button--prev');
    
  //   // Function to trigger the right button
  //   function autoClickRight() {
  //     if (!userInteracted) {
  //       rightBtn.click();
  //     }
  //   }
    
  //   // Start the interval
  //   autoClickInterval = setInterval(autoClickRight, 5000);
    
  //   // Stop auto-clicking if user clicks either button
  //   function stopAutoClick() {
  //     userInteracted = true;
  //     clearInterval(autoClickInterval);
  //   }
    
  //   // rightBtn.addEventListener('click', stopAutoClick);
  //   leftBtn.addEventListener('click', stopAutoClick);

  // }
  if (document.body.classList.contains('template-product')) {
    let autoClickInterval;
    let userInteracted = false;
  
    const sliderSection = document.querySelector('.media-gallery-inner slider-component');
    const rightBtn = document.querySelector('.media-gallery-inner slider-component .slider-button--next');
    const leftBtn = document.querySelector('.media-gallery-inner slider-component .slider-button--prev');
  
    if (sliderSection && rightBtn && leftBtn) {
      // Function to trigger the right button
      function autoClickRight() {
        if (!userInteracted) {
          rightBtn.click();
        }
      }
  
      // Stop auto-clicking if user clicks either button
      function stopAutoClick() {
        userInteracted = true;
        clearInterval(autoClickInterval);
      }
  
      leftBtn.addEventListener('click', stopAutoClick);
      // rightBtn.addEventListener('click', stopAutoClick);
  
      // Use IntersectionObserver to detect visibility
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !userInteracted) {
            // Start auto-clicking when slider is in view
            if (!autoClickInterval) {
              autoClickInterval = setInterval(autoClickRight, 8000);
            }
          } else {
            // Pause auto-clicking when slider is not in view
            clearInterval(autoClickInterval);
            autoClickInterval = null;
          }
        });
      }, {
        threshold: 0.5 // Start when at least 50% of the slider is visible
      });
  
      observer.observe(sliderSection);
    }
  }

  
});

//scroll when click on first div
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href^="#MainProduct-"]').forEach(anchor => {
    anchor.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default jump

      let target = document.querySelector('[id^="MainProduct-"]');

      if (target) {
        let offset = 100; // Adjust scroll offset
        let targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth"
        });
      }
    });
  });
});


// document.addEventListener("DOMContentLoaded", () => {
//   const targetElement = document.querySelector(".product-form__buttons .product-form__submit");
//   const header = document.querySelector(".template-product .header"); // Replace with your header selector

//   if (!targetElement || !header) return;

//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach((entry) => {
//       if (entry.isIntersecting) {
//         header.classList.remove("hidden");
//       } else {
//         header.classList.add("hidden");
//       }
//     });
//   });

//   observer.observe(targetElement);
// });


// document.addEventListener("DOMContentLoaded", () => {
//   const targetElement = document.querySelector(".product-form__buttons .product-form__submit");
//   const header = document.querySelector(".template-product .header"); // Replace with your header selector

//   if (!targetElement || !header) return;

//   // Function to set up the Intersection Observer for screens < 750px
//   const setupObserver = () => {
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           header.classList.remove("hidden");
//         } else {
//           header.classList.add("hidden");
//         }
//       });
//     });

//     observer.observe(targetElement);
//     return observer;
//   };

//   // Check for screen width and apply observer
//   const mediaQuery = window.matchMedia("(max-width: 749px)");
//   let observer;

//   const handleScreenChange = (e) => {
//     if (e.matches) {
//       // Screen width is below 750px
//       observer = setupObserver();
//     } else {
//       // Screen width is above 750px, clean up observer and ensure header is visible
//       if (observer) observer.disconnect();
//       header.classList.remove("hidden");
//     }
//   };

//   // Initial check and listener for screen width changes
//   handleScreenChange(mediaQuery);
//   mediaQuery.addEventListener("change", handleScreenChange);
// });



// document.addEventListener("DOMContentLoaded", () => {
//   const targetElement = document.querySelector(".product-form__buttons .product-form__submit");
//   const header = document.querySelector(".template-product-ian-product-template .header"); // Replace with your header selector

//   if (!targetElement || !header) return;

//   let isHeaderVisible = false;

//   // Function to set up the Intersection Observer
//   const setupObserver = () => {
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           // Show header when the target element is visible
//           if (!isHeaderVisible) {
//             header.classList.remove("hidden");
//             isHeaderVisible = true;
//           }
//         } else {
//           // Hide header only if scrolling back to the top past the target
//           const scrollTop = window.scrollY || document.documentElement.scrollTop;
//           if (scrollTop < targetElement.offsetTop) {
//             header.classList.add("hidden");
//             isHeaderVisible = false;
//           }
//         }
//       });
//     });

//     observer.observe(targetElement);
//     return observer;
//   };

//   // Media query to handle screen width
//   const mediaQuery = window.matchMedia("(max-width: 749px)");

//   const handleScreenChange = (e) => {
//     if (e.matches) {
//       // Screen width is below 750px, set up the observer
//       setupObserver();
//     } else {
//       // Screen width is above 750px, reset header visibility
//       header.classList.remove("hidden");
//     }
//   };

//   // Initial check and listener for screen width changes
//   handleScreenChange(mediaQuery);
//   mediaQuery.addEventListener("change", handleScreenChange);
// });


 //animation js
  function distanceCalculation(div1, div2) {
      // Get the dimensions and positions of the divs
      const rect1 = div1.getBoundingClientRect();
      const rect2 = div2.getBoundingClientRect();

      // Calculate the center of each div
      const center1 = {
          x: rect1.left + rect1.width / 2,
          y: rect1.top + rect1.height / 2
      };

      const center2 = {
          x: rect2.left + rect2.width / 2,
          y: rect2.top + rect2.height / 2
      };

      // Calculate the distance using the Pythagorean theorem
      const distance = Math.sqrt(
          Math.pow(center2.x - center1.x, 2) + 
          Math.pow(center2.y - center1.y, 2)
      );

      return distance;
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Cache DOM selections and constant values
    const timelineSteps = Array.from(document.querySelectorAll('.center-step'));
    const timelineSection = document.querySelector('.steps-wrapper');
    const timelineEntryPoint = document.querySelector('.steps-raws');
    const firstTimelineStep = timelineSteps[0];
    const lastTimelineStep = timelineSteps[timelineSteps.length - 1];

    if(timelineSection){
        let distanceBetweenSteps = 0;
        let stepDistances = [];
        let ticking = false; // For scroll throttling
    
        function setTimelineHeight() {
          distanceBetweenSteps = distanceCalculation(firstTimelineStep, lastTimelineStep);
          timelineEntryPoint.style.setProperty('--timeline-height', `${distanceBetweenSteps}px`);
          stepDistances = timelineSteps.map(step => distanceCalculation(firstTimelineStep, step));
        }
    
        function updateTimelineHeight() {
          const sectionRect = timelineSection.getBoundingClientRect();
          
          // Skip update if section is not visible
          if (sectionRect.bottom < 0 || sectionRect.top > window.innerHeight) {
            ticking = false;
            return;
          }
    
          const viewportMiddle = window.innerHeight * 0.6; // Simplified viewport middle point
          const distanceFromMiddle = sectionRect.top - viewportMiddle;
          const sectionHeight = sectionRect.height;
    
          let newHeight, shouldAddViewing;
    
          // If we haven't scrolled to the section yet (section is below viewport middle)
          if (distanceFromMiddle > 0) {
            newHeight = 0;
            shouldAddViewing = false;
          } 
          // If we've scrolled past the entire section
          else if (distanceFromMiddle <= -sectionHeight) {
            newHeight = distanceBetweenSteps;
            shouldAddViewing = true;
          } 
          // If we're currently scrolling through the section
          else {
            // Calculate progress (0 to 1) based on how far we've scrolled through the section
            const scrollProgress = Math.min(Math.abs(distanceFromMiddle) / sectionHeight, 1);
            // Set timeline height proportional to scroll progress
            newHeight = scrollProgress * distanceBetweenSteps;
            // Let individual steps determine their viewing state based on height
            shouldAddViewing = null;
          }
    
          timelineEntryPoint.style.setProperty('--timeline-height-dynamic', `${newHeight}px`);
    
          // Class manipulation optimization
          timelineSteps.forEach((step, index) => {
            const shouldView = shouldAddViewing !== null ? shouldAddViewing : newHeight >= stepDistances[index];
            step.classList.toggle('viewing', shouldView);
          });
    
          ticking = false;
        }
        // Init
        setTimelineHeight();
        updateTimelineHeight();
          
        
    
        // Throttled scroll handler
        function onScroll() {
          if (!ticking) {
            requestAnimationFrame(() => {
              updateTimelineHeight();
            });
            ticking = true;
          }
        }
    
        // Event listeners with throttling
        window.addEventListener('scroll', onScroll, { passive: true });
        const debouncedResize = debounce(setTimelineHeight, 250);
        window.addEventListener('resize', debouncedResize);
    
        // Debounce function
        function debounce(func, wait) {
          let timeout;
          return function executedFunction(...args) {
            const later = () => {
              clearTimeout(timeout);
              func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
          };
        }
    }

    
  });

// change content on change of review tab 
 document.addEventListener("DOMContentLoaded", function () {
    const tabBlocks = document.querySelectorAll('.tab-bar-block');
    const reviewItems = document.querySelectorAll('.review-content-item');
    const reviewcontentItems = document.querySelectorAll('.review-content-block');

    tabBlocks.forEach(tab => {
      tab.addEventListener('click', function () {
        // Remove active class from all tabs
        tabBlocks.forEach(t => t.classList.remove('active'));
        this.classList.add('active');

        const selectedTabTitle = this.getAttribute('data-tab-title');

        // Show/hide review content items
        // reviewItems.forEach(item => {
        //   const itemTabTitle = item.getAttribute('data-tab-title');
        //   if (itemTabTitle === selectedTabTitle) {
        //     item.style.display = 'flex';
        //   } else {
        //     item.style.display = 'none';
        //   }
        // });
        reviewcontentItems.forEach(item => {
          const itemTabTitle = item.getAttribute('data-tab-title');
          if (itemTabTitle === selectedTabTitle) {
            item.style.display = 'block';
          } else {
            item.style.display = 'none';
          }
        });
        
      });
    });

    // Trigger click on the first tab initially
    if (tabBlocks.length > 0) {
      tabBlocks[1].click();
    }
  });

// accordions js start common
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
      intro.onclick = (e) => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(e.target.closest('[js-acc-item]'));
        }
      };
    }
  });   
}

(function() {
  faq_taggol();  
})();



// New Js with PDP people option
// document.addEventListener("DOMContentLoaded", function () {
//   const fields_set_people = document.querySelectorAll('variant-radios fieldset.with_people');
//   console.log('fields_set_people',fields_set_people);
//   if(fields_set_people.length > 0){
//      update_qty_prices();
//   }
// });

// function update_qty_prices(){
//   const jsonScript = document.getElementById('variant_json');
//   if (!jsonScript) return;

//   let variantsJson = [];
//   try {
//     variantsJson = JSON.parse(jsonScript.textContent.trim());
//   } catch (e) {
//     console.error("Invalid variant JSON:", e);
//     return;
//   }


//   const fields_set_radios = document.querySelectorAll('variant-radios fieldset.option-quantity input[type="radio"]');

//   fields_set_radios.forEach(function(radio){
//     // Current "people" radio value
//     const qtyValue = radio.value.trim();

//     // Collect selected values from all other fieldsets
//     const otherFieldsets = document.querySelectorAll(
//       'variant-radios fieldset:not(.option-quantity)'
//     );


//     let selectedValues = [];
//     otherFieldsets.forEach(function (fieldset) {
//       const checked = fieldset.querySelector('input[type="radio"]:checked');
//       if (checked) {
//         selectedValues.push(checked.value.trim());
//       }
//     });

//     // Add the current peopleValue and previous radio value (if any)
//     if (qtyValue) selectedValues.push(qtyValue);
//     // if (prevRadioValue) selectedValues.push(prevRadioValue);

//      // Remove duplicates (if any)
//     selectedValues = [...new Set(selectedValues)];

//      // Find matching variant
//     const matchedVariant = variantsJson.find(variant => {
//       return selectedValues.every(val =>
//         variant.title.toLowerCase().includes(val.toLowerCase())
//       );
//     });


//     if (matchedVariant) {
//       console.log('Matched Variant:', matchedVariant);
//       // Example: update price on the page
//       if (matchedVariant.one_time_each) {
//         const one_time = radio.nextElementSibling.querySelector('.per_each_span .one_time')
//         if(one_time){
//           one_time.textContent = matchedVariant.one_time_each;
//         }
//       }
//       if (matchedVariant.subscription_each) {
//         const subs_time = radio.nextElementSibling.querySelector('.per_each_span .subscription')
//         if(subs_time){
//           subs_time.textContent = matchedVariant.subscription_each;
//         }
//       }
//     }

//   });
// }
// New Js with PDP people option